//

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';

@Injectable()
export class ConnectorWRemDocsESignProcessService {

    constructor(private httpClient: HttpClient, private apiService : ApiService) {
    }

    doGetWCluDocumentESignLinkItemAction_PUPRemDocsESign(_esignToken : string, _esignCode : string){
        return this.httpClient.post(this.apiService.endPointsPU.doGetWCluDocumentESignLinkItemAction_PUPRemDocsESign, { ESIGN_TOKEN : _esignToken, ESIGN_CODE: _esignCode });
    }
    
}